export default __webpack_public_path__ + "static/media/GR00019-talents_card_3.acaad10f.svg";